var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',[_c('router-link',{attrs:{"to":"/"}},[_c('img',{attrs:{"src":require("../assets/logo.svg"),"alt":"Marta Sergiej - Architekt Wnętrz"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }